export default "__VITE_ASSET__VAsp_hRO__"